import { type FC, useContext } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';

import { Link } from 'dibs-elements/exports/Link.tsx';
import ArrowLeft from 'dibs-icons/exports/legacy/ArrowLeft.ts';

import GetHelpContext from './GetHelpContext.ts';
import { ACTION_GO_BACK } from './constants.ts';
import { trackGoBackNav } from './tracking.ts';

import styles from './styles/GetHelpGoBack.scss';

const GoBack: FC = () => {
    const {
        dispatch,
        state: { step },
    } = useContext(GetHelpContext);

    return (
        <Link
            className={classnames(styles.backButtonContainer, styles.container)}
            onClick={() => {
                trackGoBackNav(step);
                dispatch({ type: ACTION_GO_BACK });
            }}
            dataTn="get-help-go-back"
        >
            <ArrowLeft className={styles.backArrow} />
            <FormattedMessage id="getHelp.GoBack.title" defaultMessage="Go Back" />
        </Link>
    );
};

export default GoBack;
